import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import createLocation from 'utils/createLocation';
import config from 'utils/config';
import { COACH_AI_ROUTE } from 'utils/routes';
import { isHelixAndLearningHub } from 'utils/helix';
import { useFetchMindsetAgent } from 'actions/userProfile';
import Button from 'components/Button';
import Flex from 'components/Flex';
import UserSkillContentModal from 'screens/UserSkillContentModal';
function parsePromptTemplate(promptTemplate, data) {
  if (typeof promptTemplate !== 'string' || (promptTemplate === null || promptTemplate === void 0 ? void 0 : promptTemplate.trim()) === '' || !data) {
    return;
  }
  return promptTemplate.trim().replace(/{{(.*?)}}/g, function (_, key) {
    var _data$key$trim;
    return (_data$key$trim = data[key.trim()]) !== null && _data$key$trim !== void 0 ? _data$key$trim : '';
  });
}

// Identical to logic in getMindsetCoachPrompt in api/modules/helixProcessing/utils/index.js
function getMindsetCoachPrompt(data) {
  var skillName = data.skillName,
    summary = data.summary,
    suggestion = data.suggestion;
  if (!summary) {
    return parsePromptTemplate(config.helixMindsetPromptNoAnalysis, data) || "I have not been showcasing the use of the skill ".concat(skillName, ". Please help coach me on how to improve.");
  }
  if (suggestion) {
    return parsePromptTemplate(config.helixMindsetPromptSummaryAndSuggestion, data) || "I have been given the following feedback and suggestions about my use of the skill ".concat(skillName, ". Please help coach me on how to improve. Feedback: \"").concat(summary, "\". Suggestion: \"").concat(suggestion, "\"");
  }
  return parsePromptTemplate(config.helixMindsetPromptOnlySummary, data) || "I have been given the following feedback about my use of the skill ".concat(skillName, ". Please help coach me on how to improve. Feedback: \"").concat(summary, "\".");
}
function ButtonRow(_ref) {
  var isCurrentUser = _ref.isCurrentUser,
    skillId = _ref.skillId,
    userId = _ref.userId,
    _ref$showContentButto = _ref.showContentButtons,
    showContentButtons = _ref$showContentButto === void 0 ? true : _ref$showContentButto,
    skillName = _ref.skillName,
    summary = _ref.summary,
    suggestion = _ref.suggestion;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFetchMindsetAgent = useFetchMindsetAgent(),
    hasMindsetAgent = _useFetchMindsetAgent.hasMindsetAgent;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSkillsContentModalOpen = _useState2[0],
    setSkillsContentModalOpen = _useState2[1];
  var search = {
    term: skillName
  };
  if (hasMindsetAgent) {
    search.q = skillName;
  }
  var coachPrompt = hasMindsetAgent ? getMindsetCoachPrompt({
    skillName: skillName,
    summary: summary,
    suggestion: suggestion
  }) : null;
  var coachingLocation = createLocation(COACH_AI_ROUTE, {
    q: coachPrompt
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Flex, {
    gap: "s",
    breakpoints: "xxs",
    flexDirection: ['column', 'row'],
    justifyContent: "right"
  }, showContentButtons && isHelixAndLearningHub && /*#__PURE__*/React.createElement(Button, {
    "aria-label": t('content_type_recommended_content_for', {
      name: skillName
    }),
    size: "medium",
    onClick: function onClick() {
      return setSkillsContentModalOpen(true);
    }
  }, t('content_type_recommended_content')), hasMindsetAgent && /*#__PURE__*/React.createElement(Button, {
    "aria-label": t('actions_coach_me_on', {
      name: skillName
    }),
    size: "medium",
    as: Link,
    to: coachingLocation
  }, t('actions_coach_me_on_this'))), isSkillsContentModalOpen && /*#__PURE__*/React.createElement(UserSkillContentModal, {
    isCurrentUser: isCurrentUser,
    userId: userId,
    skillId: skillId,
    skillName: skillName,
    onClose: function onClose() {
      return setSkillsContentModalOpen(false);
    }
  }));
}
export default ButtonRow;